import { render, staticRenderFns } from "./VabMenuItem.vue?vue&type=template&id=6fff7f32"
import script from "./VabMenuItem.vue?vue&type=script&lang=js"
export * from "./VabMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports